import { RegistrationFieldConfig } from 'interfaces/subscribe.types';
import { useQuery } from 'react-query';
import { SubscribeAPI } from 'services/subscribe.api';

/**
 * Hook React Query pour récupérer la configuration des champs
 * du formulaire d'inscription depuis le BO.
 * GET /config/registration-field-configs
 *
 * L'API retourne { fields: RegistrationFieldConfig[] },
 * on extrait le tableau.
 */
export function useRegistrationFieldConfigs() {
  return useQuery<RegistrationFieldConfig[], Error>(
    'registrationFieldConfigs',
    async () => {
      const { data } = await SubscribeAPI.getRegistrationFieldConfigs();
      const fields = data?.fields ?? [];
      return Array.isArray(fields) ? fields : [];
    },
    {
      staleTime: 5 * 60 * 1000, // 5 min cache
      retry: 1,
    },
  );
}
